import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {ThemeProvider, createTheme} from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import './index.css';

const theme = createTheme({
    typography: {
        fontFamily: 'Poppins, BlinkMacSystemFont, -apple-system, "Segoe UI", "Roboto", "Helvetica", "Arial", sans-serif',
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    margin: 0,
                    color: 'rgba(0, 0, 0, 0.87)',
                    fontWeight: 400,
                    fontSize: '1rem',
                    lineHeight: 1.5,
                    letterSpacing: '0.00938em',
                    backgroundColor: '#fff',
                },
            },
        },
    },
});

ReactDOM.render(
    <ThemeProvider theme={theme}>
        <CssBaseline/>
        <App/>
    </ThemeProvider>,
    document.getElementById('root')
);
